import { useState, useCallback } from 'react'

import CollapsableCard from 'components/CollapsableCard'
import { Button } from 'util/ui'
import { isAdmin } from 'util/agents'
import storage from 'util/storage'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_INTEGRATION_INSTALL } from 'ducks/drawers/types'

const ShopifyInstall = ({ currentAgent, credentialsLoaded, credentials }) => {
  const [hidden, setHidden] = useState(false)
  const handleDismiss = () => {
    setHidden(true)
    storage.set('hideShopifyV2InstallWidget', true)
  }
  const { openDrawer: openInstallShopifyDrawer } = useDrawer(
    DRAWER_TYPE_INTEGRATION_INSTALL
  )
  const handleClick = useCallback(
    () => openInstallShopifyDrawer('SHOPIFY_V2'),
    [openInstallShopifyDrawer]
  )

  // global feature flag
  if (!storage.get('showShopifyV2InstallWidget')) return null

  // agent dismissed widget
  if (storage.get('hideShopifyV2InstallWidget')) return null
  if (hidden) return null

  if (!credentialsLoaded) return null

  // shopify credentials exist, it's already installed
  if (credentials) return null

  if (!currentAgent) return null

  // Only show this widget for admins
  if (!isAdmin(currentAgent)) return null

  return (
    <CollapsableCard
      isLoading={false}
      persistenceKey={'customWidget.shopify_install'}
      title={'Connect Shopify'}
    >
      <div>
        <p>Manage your Shopify support right from your Groove inbox!</p>
        <ul>
          <li>See customer details &amp; timeline</li>
          <li>View customer orders &amp; statuses</li>
          <li>Handle returns &amp; cancellations</li>
          <li>Create new customer orders</li>
          <li>Easy lookup for your store products</li>
        </ul>
        <div>
          <Button primary onClick={handleClick}>
            Connect Shopify
          </Button>
          <Button basic onClick={handleDismiss}>
            Dismiss
          </Button>
        </div>
      </div>
    </CollapsableCard>
  )
}

export default ShopifyInstall
